import React from 'react';
import {
  Box, Container, Skeleton, Stack, Typography,
} from '@mui/material';
import { TripMatch } from '@marageti/z4-sdk/lib/travel';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { InfiniteScroll } from '@marageti/z4-lib';
import SoldTripsFilters from './sold-filters';
import SoldCard from '../../../components/list-cards/trip-match-cards/sold-card';

type SoldTripsViewProps = {
  countries: string[],
  disableSortBy: boolean;
  error?: ApiError,
  hasMoreItems: boolean,
  isLoading: boolean,
  items?: TripMatch[],
  loadMore: () => void,
  onChangeFilter: (n: string, v: string | string[]) => void,
  onRefreshResults?: () => void,
  partner: string;
  refineSold: string[];
  searchValue: string;
  sortBy: string,
  totalHits: string,
};

const SoldTripsView = ({
  countries,
  disableSortBy,
  error = undefined,
  hasMoreItems,
  isLoading,
  items = undefined,
  loadMore,
  onChangeFilter,
  onRefreshResults,
  partner,
  refineSold,
  searchValue,
  sortBy,
  totalHits,
}: SoldTripsViewProps) => (
  <Container maxWidth="xl">
    <Box
      sx={{
        mt: {
          desktop: 2.5,
          mobile: 3,
        },
      }}
    >
      <SoldTripsFilters
        countries={countries}
        disableSortBy={disableSortBy}
        onChange={onChangeFilter}
        partner={partner}
        refineSold={refineSold}
        searchValue={searchValue}
        sortBy={sortBy}
      />
      {isLoading ? (
        <Skeleton variant="rounded" sx={{ mb: 2, height: '24px', width: '100px' }} />
      ) : (
        <Typography variant="bodyBold" mb={2}>
          {`${totalHits === '10,000' ? `${totalHits}+` : totalHits} Result${totalHits === '1' ? '' : 's'}`}
        </Typography>
      )}
      <Stack spacing={1}>
        <InfiniteScroll
          error={error}
          hasMoreItems={hasMoreItems}
          isLoading={isLoading}
          loadMoreItems={loadMore}
        >
          {items?.flatMap((item: TripMatch) => (
            <SoldCard
              key={item.id}
              tripMatch={item}
              showReturnDate={refineSold.includes('requestReview') || refineSold.includes('waitingForReview')}
              onRefreshResults={onRefreshResults}
            />
          ))}
        </InfiniteScroll>
      </Stack>
    </Box>
  </Container>
);

export default SoldTripsView;
